<template>
  <div class="ent-certify" :style="{ color: fillColor() }">
    <el-popover
    placement="bottom"
    width="360"
    trigger="hover"
    @show="handleShow">
      <span slot="reference">
        <svg-icon
        icon-class="authorize"
        style="height: 30px;width: 30px;cursor: pointer;"
        :style="{ fill: fillColor() }"
        />
        <span style="font-size: 12px;font-weight: bold;margin-left: -5px;">{{ verifyText() }}</span>
      </span>
        <template v-if="!user.certified">
          <template v-if="verifyInfo">
            <div class="flex">
              <span>{{ verifyInfo.entName }}</span>
              <el-button type="text" style="color: #E6A23C;" v-if="verifyInfo.auditStatus == '0'">审核中</el-button>
              <el-button type="text" v-if="verifyInfo.auditStatus == '1'">审核通过</el-button>
              <el-button type="text" style="color: #a42f2f;" v-if="verifyInfo.auditStatus == '2'" @click="toVerify({ busId: verifyInfo.id, contacts: user.realName, mobileNo: user.phone })">审核不通过，重新认证</el-button>
            </div>
            <div class="content" v-if="verifyInfo.auditStatus == '2'">
              {{ verifyInfo.auditRemark }}
            </div>
            <div class="content" v-if="verifyInfo.auditStatus == '1'">
              您已通过企业认证，请<el-button type="text" @click="reLogin">重新登录</el-button>开始使用。
            </div>
          </template>
          <div class="flex" v-else>
            <span>您还未完成企业认证</span>
            <el-button type="text" @click="toVerify({ contacts: user.realName, mobileNo: user.phone })">去认证</el-button>
          </div>
        </template>
        <template v-else>
          <div class="flex">
            <span>{{ entBriefName }}</span>
            <el-button type="text">已认证</el-button>
          </div>
        </template>
    </el-popover>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { generateLink } from '@/api/login'
export default {
  name: 'EntCertify',
  data() {
    return {
    }
  },
  computed: {
    // 获取证明信息
   ...mapGetters(['verifyInfo', 'user']),
		entBriefName() {
			if(!this.user.enterpriseList) return undefined
			let entObj = this.user.enterpriseList.find(item => item.entCode == this.user.entCode)
			if(!entObj || !entObj.entBriefName) return undefined
			return entObj.entBriefName
		},
  },
  methods: {
    fillColor() {
      // 未认证
      if (!this.user.certified) {
        if (this.verifyInfo) {
          if (this.verifyInfo.isCertified == '0') {
            // 认证待审核
            if (this.verifyInfo.auditStatus == '0') {
              return '#E6A23C'
            }
            // 认证未通过
            if (this.verifyInfo.auditStatus == '2') {
              return '#a42f2f'
            }
          }
        }
        else {
          return '#ccc'
        }
      }
      else {
        return '#0039bf'
      }
    },
    verifyText() {
      // 未认证
      if (!this.user.certified) {
        if (this.verifyInfo) {
          if (this.verifyInfo.isCertified == '0') {
            // 认证待审核
            if (this.verifyInfo.auditStatus == '0') {
              return '待审核通过'
            }
            // 认证未通过
            if (this.verifyInfo.auditStatus == '2') {
              return '未通过'
            }
          }
        }
        else {
          return '未认证'
        }
      }
      else {
        return ''
      }
    },
    reLogin() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
    toVerify(data = {}) {
      generateLink(data).then(res => {
        window.open(res.url)
      })
    },
    handleShow() {
      this.$store.dispatch('GetVerifyInfo')
    }
  },
}
</script>
<style scoped lang="scss">
.ent-certify {
  height: 100%;
  display: flex;
  align-items: center;
  vertical-align: baseline;
  transform: translateY(10%);
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content {
  font-size: 12px;
  background-color: rgba(242, 242, 242, 1);
  padding: 10px;
}
</style>
